import React from 'react';

import { LoadingLogo } from '../../../assets/images';
import { FullScreenBox, LogoWrapper, TextContent,TextWrapper } from './styles';

/**
 * Componente de carregamento.
 * @returns {JSX.Element} O componente Loading.
 */
export default function Loading() {
	return (
		<FullScreenBox>
			<LogoWrapper>
				<LoadingLogo className="back-logo" />
				<div>
					<LoadingLogo className="front-logo" />
				</div>
			</LogoWrapper>
			<TextWrapper>
				<TextContent>
					<p>Carregando...</p>
					<p>Estamos quase lá</p>
					<p>Só mais um pouco</p>
				</TextContent>
			</TextWrapper>
		</FullScreenBox>
	);
}
